module.exports = __webpack_public_path__ + "static/media/avatar2.ee43831d.jpg";